import React, { useState, useEffect, useLayoutEffect } from 'react';
import TopBar from './TopBar/TopBar';
import SideBar from './SideBar/SideBar';
import CommandPaletteSearchTrigger from './CommandPaletteSearchTrigger';
import { useLocation } from 'react-router-dom'
import { Utils } from '../../../services';
import { NavbarToggler } from 'reactstrap';
import { updateUi } from '../../../redux';
import { useDispatch, useSelector } from 'react-redux';

import './Nav.css';
import './Nav.scss';

const AppShellNav = () => {
    const {
        collapsedSideBar,
        isMobile,
        isTablet,
        showNav,
        showChangelog,
        showSynchronisationPanel,
        showHealthChecks,
    }                           = useSelector(state => state.ui);
    const dispatch              = useDispatch();
    const { pathname }          = useLocation()
    const [section, setSection] = useState(Utils.SECTION_OPERATION);
    const width                 = useWindowSize();
    const overlay_open          = showSynchronisationPanel || showHealthChecks;

    useEffect(() => {
        setSection(Utils.getSectionFromPath(pathname));
    }, [pathname]);

    // If width < 768 we're on mobile display
    // If 768 <= width <= 1024 we're on tablet display
    useEffect(() => {
    // check if we need to update the state
        const newIsMobile = (width < 768);
        const newIsTablet = (width >= 768) && (width <= 1024);
        const breakpointChanged = (
            isMobile !== newIsMobile ||
            isTablet !== newIsTablet
        );

        if (!breakpointChanged)
            return;

        dispatch(updateUi({
            isMobile: newIsMobile,
            isTablet: newIsTablet,
            // Only auto-toggle the nav on breakpoint changes.
            // On mobile, showNav is user-controlled via the hamburger.
            showNav: !newIsMobile
        }));
    }, [dispatch, isMobile, isTablet, width]);


    const handleSideBarCollapse = () => {
        dispatch(updateUi({ collapsedSideBar: !collapsedSideBar }));
    }

    //width eventlistener
    function useWindowSize() {
        const [width, setWidth] = useState(0);
        useLayoutEffect(() => {
            function updateSize() {
                setWidth(window.innerWidth);
            }
            window.addEventListener('resize', updateSize);
            updateSize();
            return () => window.removeEventListener('resize', updateSize);
        }, []);
        return width;
    }

    const handleShowNav = () => {
        if (isMobile)
            dispatch(updateUi({showNav : false}))
    }

    return (
        <div className={`Nav${overlay_open ? ' Nav--overlayOpen' : ''}`}>
            {isMobile && !showChangelog && !overlay_open && (
                <div className={`Nav__mobileChrome${showNav ? ' Nav__mobileChrome--navOpen' : ''}`}>
                    <div id="nav-mobile-page-title" className="Nav__mobilePageTitle" />
                    <div id="nav-mobile-page-actions" className="Nav__mobilePageActions" />
                    {isMobile && (
                        <CommandPaletteSearchTrigger className="nav-mobile-command-search" />
                    )}
                    <NavbarToggler
                        className="navToggle"
                        onClick={() => {
                            const opening = !showNav;
                            if (opening) {
                                setSection(Utils.getSectionFromPath(pathname));
                            }
                            dispatch(updateUi({ showNav: opening }));
                        }}
                    >
                        <i className="fa fa-bars"></i>
                    </NavbarToggler>
                </div>
            )}
            {showNav &&
                <>
                    <TopBar
                        section={section}
                        onSectionSelected={setSection}
                        onCollapseNavClick={handleShowNav}
                        onToggleSideBar={handleSideBarCollapse}
                    />
                    <div className={`${collapsedSideBar ? "reducedNav" : "expandedNav"}`}>
                        <SideBar section={section} collapsed={collapsedSideBar} onCollapseNavClick={handleShowNav} />
                    </div>
                </>
            }
        </div>
    );
}

export default AppShellNav;
